import type {Result, UseCase} from 'framework';
import type {SettingsError} from '../../domain/errors';
import type {UserProfile} from '../../domain/user-profile';
import type {SettingsRepository} from '../ports/settings.repository';

export class DeleteAvatar implements UseCase<[], UserProfile> {
  constructor(private readonly repository: SettingsRepository) {}

  execute(): Promise<Result<UserProfile, SettingsError>> {
    return this.repository.deleteAvatar();
  }
}
